import { useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { useAbstractCreate } from '@/module/Author/Abstract/model/AbstractQuery';
import { AbstractSchema, abstractSchema, defaultAbstractValues } from '@/module/Author/Abstract/model/AbstractSchema';

import { useAppNotification } from '@feature/utils';

import { AbstractForm } from './AbstractForm';

export function AbstractCreate() {
  const { t } = useTranslation();
  const { mutate, isPending, isError, isSuccess } = useAbstractCreate();
  const navigate = useNavigate();
  const notification = useAppNotification();

  const onSubmit = (values: AbstractSchema) => {
    mutate(values, {
      onError: notification.error,
      onSuccess: newAbstract => {
        notification.success();
        navigate({ to: '/author/abstract/$abstractId', params: { abstractId: String(newAbstract.id) } });
      },
    });
  };

  return (
    <AbstractForm
      title={t('abstracts.form.title.create')}
      schema={abstractSchema}
      defaultValues={defaultAbstractValues}
      values={undefined}
      isSubmitting={isPending}
      isError={isError}
      isSuccess={isSuccess}
      onSubmit={onSubmit}
      onCancel={() => navigate({ to: '..' })}
      showWosFields={false}
      showScopusFields={false}
    />
  );
}
